import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IoCloseSharp, IoEyeOff, IoEye,
} from 'react-icons/io5';
import logoPng from '../../assets/truscan_logo.png';
import { loginAndCache } from '../../api/auth';          // 🆕
import './AuthModal.scss';

export default function AuthModal({ mode, onClose, onSuccess }) {
  const isLogin = mode === 'login';

  /* wizard state ----------------------------------------------------- */
  const [step,      setStep]      = useState(0);      // 0-email, 1-pw, …
  const [email,     setEmail]     = useState('');
  const [pw,        setPw]        = useState('');
  const [pw2,       setPw2]       = useState('');
  const [showPw,    setShowPw]    = useState(false);
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);  // 🆕

  /* ------------------------------------------------------------------ */
  const validate = () => {
    if (step === 0 && !email.trim())        return 'Please enter email';
    if (step === 1 && !pw.trim())           return 'Please enter password';
    if (!isLogin && step === 2 && pw2 !== pw) return 'Passwords do not match';
    return '';
  };

  /* advance or submit ------------------------------------------------- */
  const next = async () => {
    const msg = validate();
    if (msg) { setError(msg); return; }
    setError('');

    const last = (isLogin && step === 1) || (!isLogin && step === 2);
    if (!last) { setStep(step + 1); return; }

    /* ---- we are on the final screen – hit API ---------------------- */
    try {
      setLoading(true);

      if (isLogin) {
        await loginAndCache(email, pw);                // 🆕 real login
      } else {
        // TODO: sign-up endpoint
        throw new Error('Sign-up not implemented yet');
      }

      setLoading(false);
      onSuccess();      // bubble up to AuthLanding → App
    } catch (err) {
      setLoading(false);
      setError(err.message || 'Network error');
    }
  };

  /* helper ----------------------------------------------------------- */
  const InputField = ({ type, value, onChange, placeholder }) => (
    <div className={`input-wrap ${error ? 'err' : ''}`}>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        autoFocus
      />
      {type === 'password' && (
        <button
          type="button"
          className="eye"
          onClick={() => setShowPw(!showPw)}
        >
          {showPw ? <IoEye /> : <IoEyeOff />}
        </button>
      )}
    </div>
  );

  /* render ----------------------------------------------------------- */
  return (
    <div className="auth-modal">
      <button type="button" className="modal-close" onClick={onClose}>
        <IoCloseSharp />
      </button>

      <div className="modal-card">
        <img src={logoPng} alt="logo" className="logo" />
        <h2>{isLogin ? 'LOG IN' : 'CREATE ACCOUNT'}</h2>

        {/* email */}
        {step === 0 && (
          <InputField
            type="email"
            value={email}
            onChange={setEmail}
            placeholder="Email"
          />
        )}

        {/* password */}
        {step === 1 && (
          <InputField
            type={showPw ? 'text' : 'password'}
            value={pw}
            onChange={setPw}
            placeholder="Password"
          />
        )}

        {/* confirm (create only) */}
        {!isLogin && step === 2 && (
          <InputField
            type={showPw ? 'text' : 'password'}
            value={pw2}
            onChange={setPw2}
            placeholder="Confirm Password"
          />
        )}

        {error   && <p className="helper err">{error}</p>}
        {loading && <p className="helper">Signing&nbsp;in…</p>}
        {/* {isLogin && step === 0 && !loading && (
          <p className="helper">forgot password?</p>
        )} */}

        <button
          type="button"
          className="ghost-btn"
          onClick={next}
          disabled={loading}
        >
          {isLogin
            ? (step === 0 ? 'NEXT' : 'LOGIN')
            : (step < 2 ? 'NEXT' : 'CREATE')}
        </button>
      </div>
    </div>
  );
}

AuthModal.propTypes = {
  mode     : PropTypes.oneOf(['login', 'create']).isRequired,
  onClose  : PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
